import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { PageResponseModel } from '../Models/Response/PageResponseModel';

@Injectable()
export class PageService {

  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 50): PageResponseModel {
    const totalPages = Math.ceil(totalItems / pageSize);
    let startPage: number, endPage: number;

    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {

        if ((totalPages - (currentPage - 2)) === 5) {
          startPage = currentPage - 1;
          endPage = currentPage + 3;
        } else {
          startPage = currentPage - 2;
          endPage = currentPage + 2;
        }
      }
    }
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    const pages = _.range(startPage, endPage + 1);

    const model = new PageResponseModel();
    model.totalItems = totalItems;
    model.currentPage = currentPage + 1;
    model.pageSize = pageSize;
    model.totalPages = totalPages;
    model.startPage = startPage;
    model.endPage = endPage;
    model.startIndex = startIndex;
    model.endIndex = endIndex;
    model.pages = pages;

    return model;
  }

}